import { Link } from "react-router-dom";
import { company } from "../mock/mock";

export default function Logo({ variant = "dark", compact = false }) {
  const isLight = variant === "light";
  return (
    <Link to="/" className="flex items-center gap-3 group" aria-label="Mahalaxmi Tape Industries Home">
      <div className="relative">
        <div
          className={`w-12 h-12 ${
            compact ? "w-10 h-10" : ""
          } rounded-md grid place-items-center bg-[#c8102e] shadow-md group-hover:rotate-3 transition-transform`}
          style={{
            backgroundImage: "linear-gradient(135deg,#c8102e,#9a0c24)",
          }}
        >
          <span className="text-white font-extrabold text-xl tracking-tight">M</span>
          <span className="absolute -right-1 -top-1 w-3 h-3 rounded-full bg-[#f4b223] border-2 border-white" />
        </div>
      </div>
      <div className="leading-tight">
        <div
          className={`font-heading font-extrabold text-[15px] sm:text-[17px] ${
            isLight ? "text-white" : "text-[#0d2240]"
          }`}
        >
          {company.name}
        </div>
        <div
          className={`text-[10.5px] sm:text-xs uppercase tracking-[0.18em] ${
            isLight ? "text-white/70" : "text-[#c8102e]"
          }`}
        >
          Adhesive Tape Manufacturers
        </div>
      </div>
    </Link>
  );
}
